"use client";

import { usePathname } from "next/navigation";
// import { useEffect, useState } from "react";
import NavbarPage3 from "@/components/Navbar/page3";
import NavbarPage2 from "@/components/Navbar/page2";
import Script from "next/script";
import { BannerProvider } from "@/context/BannerContext";

export default function ClientLayout({ children, menuData }) {
  const pathname = usePathname();
  const isHome = pathname === "/" || pathname === "" || pathname === null;
  const isPlacement = pathname === "/placement-cell-and-activities";
  const isWise = pathname === "/wise";
  const isNationalSummit = pathname === "/events/national-skill-and-workforce-summit-2026";

  
  return (
    <BannerProvider>
      <ClientLayoutContent children={children} menuData={menuData} isHome={isHome} isWise={isWise} isPlacement={isPlacement} isNationalSummit={isNationalSummit} />
    </BannerProvider>
  );
}

// Don't subscribe to BannerContext or media queries here unless the value is
// used: every update re-renders the whole navbar (slows taps / INP).
function ClientLayoutContent({ children, menuData, isHome, isWise, isPlacement, isNationalSummit }) {
  return (
    <>
      {!isNationalSummit && (
        isPlacement ? (
            <NavbarPage3 menuData={menuData} />
          ) : (
            <NavbarPage2 menuData={menuData} isWise={isWise} />
          )
      )}
     
      {children}
    </>
  );
}
